import Text from 'components/commons/Text';
import Button from 'components/input/Button';
import InputField from 'components/input/InputField';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Row } from 'saladsoft-primitive';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';

const ListDeletingForm = ({ listing }: { listing: any }) => {
  const navigate = useNavigate();

  const { uiStore } = useStoreWrapper();

  const [inputValue, setInputValue] = useState<string>('');

  const handleClickDelete = () => {
    ServiceHelper.adminListingService?.deleteListing(Number(listing.id)).then((res: any) => {
      if (res.status < 300) {
        uiStore?.modal.close();
        toast.success('시설이 삭제되었습니다.');
        navigate('/admin/listings');
      }
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Text type="H3" style={{ marginBottom: 20 }}>
        '{listing?.localizedName?.ko}' 숙소를 삭제하시겠습니까?
      </Text>
      <Text type="H4" buttonRole="DESCRIPTION">
        삭제를 위해 아래 입력폼에 '확인'이라고 입력 해 주세요
      </Text>
      <InputField
        placeholder="확인"
        style={{ width: 300, margin: '20px 0' }}
        onChange={(value: string) => {
          setInputValue(value);
        }}
      />
      <Row gap="10px">
        <Button
          type="outlined"
          style={{
            background: '#efefef',
            color: '#414141',
            border: 'none',
            width: 200,
            cursor: 'pointer',
          }}
          onClick={() => {
            uiStore?.modal.close();
          }}
        >
          취소
        </Button>
        <Button
          onClick={handleClickDelete}
          isValid={inputValue === '확인' ? true : false}
          style={{ width: 100 }}
        >
          삭제확인
        </Button>
      </Row>
    </div>
  );
};

export default ListDeletingForm;
